import { Loading, RingroundSnackbar } from 'Shared/components'
import MessageHistory from '../MessageHistory'
import MessageSender from '../MessageSender'
import EmptyView from './EmptyView'
import TopBar from './TopBar'
import useData from 'DesktopMessager/useData'
import TargetInfo from "Shared/components/TargetInfoNew"
import './PageContainer.scoped.scss'
import MobileTabs from 'Shared/components/Tabs/MobileTabs'
import Tab from "Shared/components/Tabs/Tab"
import { useWindowSize } from 'usehooks-ts'
import { MOBILE_SCREEN_WIDTH } from 'Shared/constants'
import useAct from 'DesktopMessager/useAct'

// TODO: replace with redux / async calls to populate data
// import { elObserver } from './helpers'

const PageContainer = () => {
  const act = useAct()
  const size = useWindowSize()
  const name = useData(rs => rs.campaign.name)
  const slug = useData(rs => rs.campaign.slug)
  const conversationId = useData(rs => rs.user.currentConversationId)
  const dataLoaded = useData(rs => {
    return (rs.user && rs.campaign && rs.target?.id) || (rs.user?.id && !rs.user.currentConversationId)
  })
  const pusherConnected = useSel(s => s.local.pusherConnected)
  const loaded = pusherConnected && dataLoaded
  const target = useData(rs => rs.target)
  const noMoreMessages = loaded && !conversationId
  const hasSurvey = false

  const [tabIndex, setTabIndex] = useState(0)

  const desktopSize = size.width >= MOBILE_SCREEN_WIDTH
  const showTargetInfo = size.width >= MOBILE_SCREEN_WIDTH || tabIndex === 0
  const showConversation = size.width >= MOBILE_SCREEN_WIDTH || tabIndex === 1
  const showSurvey = hasSurvey && (desktopSize || tabIndex === 2)
  const noConversation = loaded && !conversationId
  const lastPingTimeRef = useRef(Date.now())
  const [sessionExpired, setSessionExpired] = useState(false)

  const checkAndHandleExpiration = (shouldRedirect = false) => {
    const timeSinceLastPing = Date.now() - lastPingTimeRef.current
    const tenMinutes = 10 * 60 * 1000

    if (timeSinceLastPing > tenMinutes && !sessionExpired) {
      setSessionExpired(true)
      if (shouldRedirect) window.location.href = `/campaigns/${slug}?session_expired=true`

      return true
    }
    return false
  }

  useEffect(() => {
    function ping() {
      if (!document.hidden) {
        if (checkAndHandleExpiration(false)) {
          return
        }

        act.user.ping(() => {
          lastPingTimeRef.current = Date.now()
        })
      }
    }

    const interval = setInterval(ping, 60000)
    ping()

    return () => clearInterval(interval)
  }, [slug])

  useEffect(() => {
    const interval = setInterval(() => checkAndHandleExpiration(true), 1000)
    return () => clearInterval(interval)
  }, [slug])

  return (
    <div className="messager-root">
      <TopBar title={name} noMoreMessages={noMoreMessages} />
      <RingroundSnackbar />

      <div className="main">
        {!loaded && <Loading text={i18n.t('user.campaigns.text.loading_conversations')} />}
        {noConversation && <EmptyView />}

        {(loaded && !noConversation) &&
          <div className={hasSurvey ? 'columns has-survey' : 'columns no-survey'}>
            {showTargetInfo &&
              <div className="left-sidebar">
                {target && <TargetInfo target={target} icon={'sms'} />}
              </div>
            }

            {showConversation && target && target.id &&
              <div className={desktopSize ? 'conversations box' : 'conversations'}>
                <div class="scroll">
                  <MessageHistory />
                </div>
                <div class="wrap-message-sender">
                  <MessageSender />
                </div>
              </div>
            }

            {showSurvey &&
              <div className="right-sidebar">
              </div>
            }
          </div>
        }
      </div>

      {size.width < MOBILE_SCREEN_WIDTH &&
        <MobileTabs value={tabIndex} onChange={setTabIndex}>
          <Tab label="Member Info" />
          <Tab label="Messages" />
          {hasSurvey && <Tab label="Survey" />}
        </MobileTabs>
      }

    </div>
  )
}

export default PageContainer
